import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { nextPage, prevPage } from '../store/actions/commonActions';

class ListPagination extends Component {
  render() {
    const min = this.props.min;
    const max = this.props.max;
    const numItems = this.props.numItems;
    const currentPage = this.props.currentPage;
    const totalPages = this.props.totalPages;
    const dispatchType = this.props.dispatchType;
    const fetchCallback = this.props.fetchCallback;
    
    return (
      <Row>
        <Col>
          { min } - { max } of { numItems }
          <Button id="paginate-left" className="btn-primary shadow-none paginate-button" onClick={() => {
            window.scrollTo(0, 0);
            this.props.prevPage(dispatchType, min, max, currentPage, totalPages, numItems, fetchCallback);
            document.body.style.overflow = 'scroll';
          }}>
            <FontAwesomeIcon icon={faChevronLeft} style={{color: "#ffffff",}} />
          </Button>
          <Button id="paginate-right" className="btn-primary shadow-none paginate-button" onClick={() => {
            window.scrollTo(0, 0);
            this.props.nextPage(dispatchType, min, max, currentPage, totalPages, numItems, fetchCallback);
            document.body.style.overflow = 'scroll';
          }}>
            <FontAwesomeIcon icon={faChevronRight} style={{color: "#ffffff",}} />
          </Button>
        </Col>
      </Row>
    )
  }
}

export const mapStateToProps = (state) => {
  return ({
    common: state.common
  })
}

export const mapDispatchToProps = (dispatch) => {
  return {
    nextPage: (...args) => dispatch(nextPage(...args)),
    prevPage: (...args) => dispatch(prevPage(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListPagination)
